import { Keypair } from '@solana/web3.js'
import {
  GetMetadataResponse,
  PostVideoResponse,
  PublishVideoRequest,
  PutThumbnailRequest,
  PutVideoRequest,
} from '../interfaces'
import { GET, POSTWithAuth, PUTWithAuthNoResponse } from './Index'

export async function PostVideo(mint: Keypair, gated: boolean): Promise<PostVideoResponse> {
  return await POSTWithAuth<{ gated: boolean; private_key: string }, PostVideoResponse>(
    `https://athena-${process.env.NEXT_PUBLIC_ENVIRONMENT}.glassapi.xyz/videos/${mint.publicKey}`,
    {
      private_key: mint.secretKey.toString(),
      gated,
    }
  )
}

export async function PutVideo(mint: string, title?: string, description?: string): Promise<void> {
  return await PUTWithAuthNoResponse<PutVideoRequest>(
    `https://athena-${process.env.NEXT_PUBLIC_ENVIRONMENT}.glassapi.xyz/videos/${mint}`,
    {
      title,
      description,
    }
  )
}

export async function PublishVideo(mint: string): Promise<void> {
  return await PUTWithAuthNoResponse<PublishVideoRequest>(
    `https://athena-${process.env.NEXT_PUBLIC_ENVIRONMENT}.glassapi.xyz/videos/${mint}`,
    {
      minted: true,
    }
  )
}

export async function PutThumbnail(mint: string, data_uri: string): Promise<void> {
  return await PUTWithAuthNoResponse<PutThumbnailRequest>(
    `https://athena-${process.env.NEXT_PUBLIC_ENVIRONMENT}.glassapi.xyz/videos/${mint}/thumbnail`,
    {
      data_uri,
    }
  )
}

export async function GetMetadata(mint: string): Promise<GetMetadataResponse> {
  return await GET<GetMetadataResponse>(
    `https://athena-${process.env.NEXT_PUBLIC_ENVIRONMENT}.glassapi.xyz/metadata/${mint}`
  )
}
